import React, { useState, useEffect } from 'react'
import "./css/AllOrders.css";
import Order from './Order';
import { firestore, auth } from '../firebase';
import { useStateValue } from './StateProvider'
import { useHistory } from 'react-router-dom'

function AllOrder() {
    const history = useHistory();
    const [statusFilter, setStatusFilter] = useState("");
    const [priceFilter, setPriceFilter] = useState('');
    const [filteredProducts, setFilteredProducts] = useState([]);
    const [productIds, setProductIds] = useState([]);
    const [theProducts, setTheProducts] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [{basket, user}, dispatch] = useStateValue();

    useEffect(() => {
      const userStoriesRef = firestore.collection('orders');
  
      const unsubscribe = userStoriesRef.onSnapshot((querySnapshot) => {
        const ids = [];
        const userStoriesData = [];
  
        querySnapshot.forEach((doc) => {
          ids.push(doc.id);
          const data = doc.data();
          userStoriesData.push(data);
        });
  
        setProductIds(ids);
        setTheProducts(userStoriesData);
      });
  
      return () => {
        unsubscribe();
      };
    }, []);
  
    useEffect(() => {
      const filterProduct = () => {
        const filtered = theProducts.filter((data) => {
          const statusMatch = statusFilter === '' || data?.status === statusFilter;
  
          const priceMatch =
            priceFilter === '' ||
            (priceFilter === 'at $1 - $249' && data?.price > 0 && data?.price < 250) ||
            (priceFilter === 'at $250 - $499' && data?.price >= 250 && data?.price < 500) ||
            (priceFilter === 'at $500 - $999' && data?.price >= 500 && data?.price < 1000) ||
            (priceFilter === 'at $1000 and above' && data?.price >= 1000);
  
          return statusMatch && priceMatch;
        });
  
        setFilteredProducts(filtered);
      };
  
      filterProduct();
    }, [statusFilter, priceFilter, theProducts]);

    const filteredCustomers = theProducts.filter((data) =>
    data.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className='all-orders'>
        <h3>All Orders ({filteredProducts.length})</h3>

        <div className='order-filter'>
            <select onChange={(e) => setPriceFilter(e.target.value)} style={{marginRight: "10px"}}>
                <option value="">Select Price</option>
                <option value="at $1 - $249">$1 - $249</option>
                <option value="at $250 - $499">$250 - $499</option>
                <option value="at $500 - $999">$500 - $999</option>
                <option value="at $1000 and above">$1000 and above</option>
              </select>
            <select onChange={(e) => setStatusFilter(e.target.value)} style={{marginRight: "10px"}}>
                <option value="">Status</option>
                <option value="Delivered">Delivered</option>
                <option value="Pending">Pending</option>
                <option value="Canceled">Canceled</option>
            </select>

            <input type='search'
            placeholder='Search Customer Name...'
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            />
        </div>

        <div className='orders-row'>
        {filteredProducts.length === 0 ? (
            <span style={{ textAlign: 'left', fontFamily: 'sans-serif', paddingTop: '20px', fontWeight: 'bold' }} >
              No Orders found.
            </span>
          ) : (
            <>
              {filteredProducts.map((data, index) => (
                <Order key={index} data={data} productId={productIds[index]} />
              ))}
            </>
          )}
        </div>
    </div>
  )
}

export default AllOrder
